import type { PartnerPackagingV2Create } from '@shipium-corp/shipium-ts-types';
import { PACKAGING_STATUS } from '../../../../../components/packaging/PackagingFormV2';
import { sortedShipumDimension } from '../../../../../store/partner/packageFileUtils';

export const buildPackagingRequestBody = (formData: any): PartnerPackagingV2Create => ({
  name: formData.name,
  description: formData.description,
  packagingSizeName: formData.packagingSizeName,
  packagingMaterial: formData.packagingMaterial,
  partnerProvidedId: formData.partnerProvidedId,
  linearDimensions: {
    ...sortedShipumDimension(formData.length, formData.width, formData.height),
    linearUnit: formData.linearUnit,
  },
  maxContentWeight: {
    weightUnit: formData.weightUnit,
    weight: formData.maxContentWeight,
  },
  packagingWeight: {
    weightUnit: formData.weightUnit,
    weight: formData.packagingWeight,
  },
  unsupportedProductDetails: formData.unsupportedProductDetails || [],
  active: formData.packagingActive === PACKAGING_STATUS.ACTIVE,
  archived: false,
});
